import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { getUserVehicles, deleteVehicle } from '../services/vehicleCrudService'
import VehicleCard from '../Components/VehicleCard'
import './MyVehicles.css'

const MyVehicles = () => {
  const { user } = useAuth()
  const navigate = useNavigate()

  const [vehicles, setVehicles] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!user) {
      navigate('/')
      return
    }

    loadUserVehicles()
  }, [user, navigate])

  const loadUserVehicles = async () => {
    try {
      setLoading(true)
      const data = await getUserVehicles(user.id)
      setVehicles(data)
    } catch (err) {
      console.error('Error cargando vehículos:', err)
      setError('Error al cargar tus vehículos')
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async vehicleId => {
    if (!window.confirm('¿Estás seguro de que quieres eliminar este vehículo?')) {
      return
    }

    try {
      await deleteVehicle(vehicleId, user.id)
      alert('✅ Vehículo eliminado correctamente')
      loadUserVehicles() // Recargar lista
    } catch (err) {
      console.error('Error eliminando vehículo:', err)
      alert('❌ Error al eliminar el vehículo')
    }
  }

  if (!user) {
    return null
  }

  return (
    <div className='my-vehicles-page'>
      <div className='my-vehicles-container'>
        <div className='my-vehicles-header'>
          <button className='back-button' onClick={() => navigate('/')}>
            ← Volver
          </button>
          <h1>Mis Vehículos</h1>
          <button className='add-new-btn' onClick={() => navigate('/add-vehicle')}>
            + Añadir Vehículo
          </button>
        </div>

        {error && <div className='error-message'>{error}</div>}

        {loading ? (
          <div className='loading-message'>Cargando tus vehículos...</div>
        ) : vehicles.length === 0 ? (
          <div className='empty-state'>
            <p>Aún no has añadido ningún vehículo</p>
            <button className='add-first-btn' onClick={() => navigate('/add-vehicle')}>
              + Añadir tu primer vehículo
            </button>
          </div>
        ) : (
          <div className='vehicles-grid'>
            {vehicles.map(vehicle => (
              <div key={vehicle['vehicle_id(PK)']} className='vehicle-card-wrapper'>
                <VehicleCard vehicle={vehicle} />
                <div className='vehicle-actions'>
                  <button className='edit-btn' onClick={() => navigate(`/edit-vehicle/${vehicle['vehicle_id(PK)']}`)}>
                    ✏️ Editar
                  </button>
                  <button className='delete-btn' onClick={() => handleDelete(vehicle['vehicle_id(PK)'])}>
                    🗑️ Eliminar
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default MyVehicles
